import { pagination } from 'instantsearch.js/es/widgets';

// TODO: Determine if using 'id' would be better to target HTML elements rather than class names for the algolia widgets
const paginationContainer = document.querySelector(
	'.algolia-search-list-page__pagination',
);

const paginationNavigationItems = {
	'.ais-Pagination-item--firstPage': 'paginationFirstPage',
	'.ais-Pagination-item--previousPage': 'paginationPreviousPage',
	'.ais-Pagination-item--nextPage': 'paginationNextPage',
	'.ais-Pagination-item--lastPage': 'paginationLastPage',
};

const paginationObserver = new MutationObserver(() => {
	addIdsToPaginationNavigation();
	addIdsToPaginationPages();
});

if (paginationContainer) {
	paginationObserver.observe(paginationContainer, {
		subtree: true,
		childList: true,
	});
}

const addIdsToPaginationNavigation = () => {
	const keys = Object.keys(paginationNavigationItems);

	for (let index = 0; index < keys.length; index++) {
		const itemClass = keys[index];
		const id = paginationNavigationItems[itemClass];
		const item = document.querySelector(itemClass);
		item.firstChild.id = id;
	}
};

const addIdsToPaginationPages = () => {
	const pages = document.querySelectorAll('.ais-Pagination-item--page');

	for (let index = 0; index < pages.length; index++) {
		const page = pages[index];
		page.firstChild.id = `paginationPage${index + 1}`;
	}
};

export const initPagination = () => {
	return pagination({
		container: paginationContainer,
		padding: 2,
	});
};
